import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadModule, FileUploadComponent } from '@iplab/ngx-file-upload';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { YesNoPipe } from './pipes/yesno.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { ToNumberPipe } from './pipes/toNumber.pipe';
import { AppOfflineDialogComponent } from './app-offline-dialog/app-offline-dialog.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import { MarkAsteriskDirective } from './directives/mark-asterisk.directive';
import { ErrorSnackbarComponent } from './error-snackbar/error-snackbar.component';
import { EmailToNamePipe } from './pipes/emailToName.pipe';
import { RoundToTwoDecimalPlacesPipe } from './pipes/round-to-two-decimal-places.pipe';
// Material Modules
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [
        ConfirmationDialogComponent,
        AppOfflineDialogComponent,
        YesNoPipe,
        OrderByPipe,
        ToNumberPipe,
        MarkAsteriskDirective,
        ErrorSnackbarComponent,
        EmailToNamePipe,
        RoundToTwoDecimalPlacesPipe,
    ],
    imports: [
        CommonModule,
        FormsModule,
        FileUploadModule,
        MaterialModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule
    ],
    exports: [
        YesNoPipe,
        OrderByPipe,
        ToNumberPipe,
        FileUploadComponent,
        MarkAsteriskDirective,
        EmailToNamePipe,
        RoundToTwoDecimalPlacesPipe,
        MatDialogModule,
        MatButtonModule,
        MatIconModule
    ],
    providers: [
        OrderByPipe,
        EmailToNamePipe,
        RoundToTwoDecimalPlacesPipe,
    ]
})
export class SharedModule { }
